import React, { useEffect, useState } from 'react';
import { Share2, Calendar, User, Eye } from 'lucide-react';
import Navbar from './navbar';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { showErrorToast, showSuccessToast } from './toast';
import curvedBanner from "../assect/images/bg/dl_curvedimg_troy.png";

const BlogLandingPage = () => {
  const { slug } = useParams();
  const [blog, setBlog] = React.useState(null);
  const [recentBlogs, setRecentBlogs] = React.useState([]);
  const [initialLoading, setInitialLoading] = useState(false);

  const fetchRecentBlogs = async (pageNumber = 1, isInitialLoad = false) => {
    try {
      const getBlogPath = `${process.env.REACT_APP_API_URL}api/Blogs?page=${pageNumber}&pageSize=${4}&status=1`;
      const token = localStorage.getItem("token");

      const res = await axios.get(getBlogPath, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      // const data = res.data;
      const data = res.data.blogs.filter(b => b.slug !== (slug)); // Exclude current blog

      // Take only the first 3 blogs after filtering
      const topThreeBlogs = data.slice(0, 3);

      // Set to state
      setRecentBlogs(topThreeBlogs);

    } catch (error) {
      showErrorToast("Failed to fetch properties");
      console.error(error);
    } finally {
      setInitialLoading(false);
    }
  };
  const getBlogBySlug = async (slug) => {
    const getBlogPath = `${process.env.REACT_APP_API_URL}api/Blogs/${slug}`;
    const token = localStorage.getItem("token");

    try {
      const res = await axios.get(getBlogPath, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      setBlog(res.data);
      return res.data;

    } catch (error) {
      console.error("Error getting blog:", error);
      showErrorToast("Error getting blog");
      if (error.response && error.response.status === 401) {
        showErrorToast("Unauthorized: Please log in again.");
      }
      throw error;
    }
  };
  const increaseViewCount = async (slug) => {
    const increaseViewCountPath = `${process.env.REACT_APP_API_URL}api/Blogs/${slug}/viewed`;
    const token = localStorage.getItem("token");

    try {
      const res = await axios.patch(
        increaseViewCountPath,
        {}, // <-- Empty body
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
    } catch (error) {
      console.error("Error increasing view count:", error);
      showErrorToast("Error increasing view count");

      if (error.response && error.response.status === 401) {
        showErrorToast("Unauthorized: Please log in again.");
      }
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };
  const navigate = useNavigate();

  const fetchViewsAndRecentBloags = async (slug) => {
    await increaseViewCount(slug)
    await getBlogBySlug(slug);
    fetchRecentBlogs(1)
  }

  useEffect(() => {
    fetchViewsAndRecentBloags(slug)
  }, [slug])

  return (
    <div style={{ background: '#f5ede3', minHeight: '100vh' }}>
      {/* Navigation */}
      <Navbar navClass="defaultscroll sticky" menuClass="navigation-menu nav-right" />

      {/* Hero Section */}
      <div
        className='d-flex align-items-center justify-content-center'
        style={{
          // backgroundImage: `url(${curvedBanner})`,
          backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${curvedBanner})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '400px',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        <div className='py-5'>
          <h1 className='fs-1 fw-bold text-white text-center'>
            {blog?.title}
          </h1>
        </div>
      </div>

      {/* Main Content */}
      <div style={{ maxWidth: '100vw', margin: '0 auto', padding: '50px 20px' }}>
        <div className='row gap-y-5' style={{ rowGap: '20px' }}>
          {/* Article Section */}
          <div className='col-lg-9'>
            {/* Featured Image - Large */}
            <div style={{ marginBottom: '40px', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(0,0,0,0.12)' }}>
              <div style={{ position: 'relative', aspectRatio: '16/9', overflow: 'hidden', background: '#e8dcc8' }}>
                <img
                  src={`${process.env.REACT_APP_API_URL}${blog?.featureImageUrl}`}
                  alt={blog?.thumbnailImageAlt}
                  style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.5s ease' }}
                  onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                  onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                />
              </div>
            </div>

            {/* Article Content */}
            <article style={{ background: 'white', borderRadius: '12px', padding: '50px', boxShadow: '0 8px 30px rgba(0,0,0,0.08)' }}>
              <div style={{ marginBottom: '40px' }}>
                <p style={{ fontSize: '17px', color: '#666', lineHeight: '1.8', fontWeight: '500' }}>
                  {blog?.shortDesc}
                </p>
              </div>

              <div style={{ height: '1px', background: '#a07242', marginBottom: '40px', opacity: '0.3' }} />

              <div
                style={{
                  fontSize: '16px',
                  lineHeight: '1.9',
                  color: '#444'
                }}
              >
                <style>{`
                  .blog-content h2 { font-size: 30px; font-weight: 700; margin: 40px 0 20px 0; color: #1f2937; }
                  .blog-content h3 { font-size: 22px; font-weight: 600; margin: 30px 0 15px 0; color: #2d3748; }
                  .blog-content p { margin-bottom: 18px; }
                  .blog-content strong { color: #a07242; font-weight: 600; }
                `}</style>
                <div className="blog-content" dangerouslySetInnerHTML={{ __html: blog?.htmlContent }} />
              </div>

              <div style={{ height: '1px', background: '#a07242', margin: '50px 0 40px 0', opacity: '0.3' }} />

              {/* Tags */}
              {blog?.metaKeywords && (
                <div>
                  <h6 style={{ fontSize: '13px', color: '#999', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '1.2px', fontWeight: '600' }}>
                    Tags
                  </h6>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                    {blog?.metaKeywords.split(',').map((keyword, idx) => (
                      <span
                        key={idx}
                        style={{
                          background: '#f5ede3',
                          color: '#a07242',
                          padding: '8px 14px',
                          borderRadius: '25px',
                          fontSize: '13px',
                          fontWeight: '600',
                          cursor: 'pointer',
                          border: '1px solid #e8dcc8',
                          transition: 'all 0.2s ease',
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.background = '#a07242';
                          e.target.style.color = 'white';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.background = '#f5ede3';
                          e.target.style.color = '#a07242';
                        }}
                      >
                        {keyword.trim()}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </article>
          </div>

          {/* Sidebar - Only what's in the model */}
          <div className='col-lg-3'>
            <div style={{ position: 'sticky', top: '30px' }}>


              {/* Meta Info Card - Based on actual model fields */}
              <div style={{ background: 'white', borderRadius: '12px', padding: '24px', boxShadow: '0 6px 20px rgba(0,0,0,0.06)' }}>
                {/* Published Date */}
                <div style={{ marginBottom: '18px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                    <div style={{ background: '#f5ede3', padding: '8px', borderRadius: '6px', color: '#a07242' }}>
                      <Calendar size={16} />
                    </div>
                    <small style={{ color: '#999', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase' }}>Published</small>
                  </div>
                  <p style={{ fontSize: '13px', fontWeight: '600', color: '#1f2937', margin: '0' }}>
                    {formatDate(blog?.creationTime)}
                  </p>
                </div>

                <div style={{ height: '1px', background: '#e8dcc8', marginBottom: '18px' }} />

                {/* Creator */}
                <div style={{ marginBottom: '18px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                    <div style={{ background: '#f5ede3', padding: '8px', borderRadius: '6px', color: '#a07242' }}>
                      <User size={16} />
                    </div>
                    <small style={{ color: '#999', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase' }}>Author</small>
                  </div>
                  <p style={{ fontSize: '13px', fontWeight: '600', color: '#1f2937', margin: '0' }}>
                    {"Dimora Living"} {/* Static for now as model lacks user details */}
                  </p>
                </div>

                <div style={{ height: '1px', background: '#e8dcc8', marginBottom: '18px' }} />

                {/* Views */}
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                    <div style={{ background: '#f5ede3', padding: '8px', borderRadius: '6px', color: '#a07242' }}>
                      <Eye size={16} />
                    </div>
                    <small style={{ color: '#999', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase' }}>Views</small>
                  </div>
                  <p style={{ fontSize: '13px', fontWeight: '600', color: '#1f2937', margin: '0' }}>
                    {blog?.blogViewed.toLocaleString()} reads
                  </p>
                </div>

                {/* Last Modified */}
                {blog?.lastModificationTime && (
                  <>
                    <div style={{ height: '1px', background: '#e8dcc8', margin: '18px 0' }} />
                    <div>
                      <small style={{ color: '#999', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase' }}>Last Updated</small>
                      <p style={{ fontSize: '13px', fontWeight: '600', color: '#1f2937', margin: '6px 0 0 0' }}>
                        {formatDate(blog?.lastModificationTime)}
                      </p>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Related Articles Section */}
      {/* {recentBlogs?.length > 0 && <div style={{ background: 'white', marginTop: '60px', padding: '60px 20px', borderTop: '1px solid #e8dcc8' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ marginBottom: '40px' }}>
            <h3 style={{ fontSize: '32px', fontWeight: '700', color: '#1f2937', margin: '0' }}>Recent Articles</h3>
            <div style={{ width: '50px', height: '3px', background: '#a07242', borderRadius: '2px', marginTop: '12px' }} />
          </div>
          <div 
          style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px' }}
          >
            {recentBlogs.map((item,index) => (
              <div
                key={index}
                style={{
                  background: 'white',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  boxShadow: '0 6px 20px rgba(0,0,0,0.06)',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  border: '1px solid #e8dcc8'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.boxShadow = '0 16px 40px rgba(160, 114, 66, 0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.06)';
                }}
              >
                <div style={{ height: '200px', overflow: 'hidden', position: 'relative' }}>
                  <img
                    src={`${process.env.REACT_APP_API_URL}${item?.thumbnailImageUrl}`}
                    alt="Related article"
                    style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.4s ease' }}
                    onMouseEnter={(e) => e.target.style.transform = 'scale(1.1)'}
                    onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                  />
                </div>
                <div style={{ padding: '24px' }}>
                  <h6 style={{ fontSize: '16px', fontWeight: '700', color: '#1f2937', marginBottom: '10px', lineHeight: '1.4' }}>
                    {item.title}
                  </h6>
                  <p style={{ fontSize: '13px', color: '#999', marginBottom: '16px', lineHeight: '1.6' }}>
                    {item.shortDesc}
                  </p>
                  <a
                    href="#"
                    style={{
                      display: 'inline-block',
                      color: '#a07242',
                      fontWeight: '600',
                      fontSize: '13px',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                    onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                    onClick={(e) => {
                      e.preventDefault(); // ✅ prevents "#" from showing in URL
                      navigate(`/blog/${item.slug}`);
                      window.scrollTo({ top: 0, behavior: 'smooth' }); // 👈 Scrolls to top smoothly
                    }}
                  >
                    Read More →
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      } */}
      {recentBlogs?.length > 0 && (
        <div
          style={{
            background: "white",
            marginTop: "60px",
            padding: "60px 20px",
            borderTop: "1px solid #e8dcc8",
          }}
        >
          <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
            <div style={{ marginBottom: "40px" }}>
              <h3
                style={{
                  fontSize: "32px",
                  fontWeight: "700",
                  color: "#1f2937",
                  margin: "0",
                }}
              >
                Recent Articles
              </h3>
              <div
                style={{
                  width: "50px",
                  height: "3px",
                  background: "#a07242",
                  borderRadius: "2px",
                  marginTop: "12px",
                }}
              />
            </div>

            {/* Grid Layout */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns:
                  recentBlogs.length === 1
                    ? "minmax(300px, 600px)" // 👈 limit width when 1 blog
                    : "repeat(auto-fit, minmax(300px, 1fr))",
                justifyContent:
                  recentBlogs.length === 1 ? "center" : "space-between", // 👈 center single card
                gap: "30px",
              }}
            >
              {recentBlogs.map((item, index) => (
                <div
                  key={index}
                  style={{
                    background: "white",
                    borderRadius: "12px",
                    overflow: "hidden",
                    boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    border: "1px solid #e8dcc8",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-8px)";
                    e.currentTarget.style.boxShadow =
                      "0 16px 40px rgba(160, 114, 66, 0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 6px 20px rgba(0,0,0,0.06)";
                  }}
                >
                  <div
                    style={{
                      height: "200px",
                      overflow: "hidden",
                      position: "relative",
                    }}
                  >
                    <img
                      src={`${process.env.REACT_APP_API_URL}${item?.thumbnailImageUrl}`}
                      alt="Related article"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        transition: "transform 0.4s ease",
                      }}
                      onMouseEnter={(e) => (e.target.style.transform = "scale(1.1)")}
                      onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
                    />
                  </div>
                  <div style={{ padding: "24px" }}>
                    <h6
                      style={{
                        fontSize: "16px",
                        fontWeight: "700",
                        color: "#1f2937",
                        marginBottom: "10px",
                        lineHeight: "1.4",
                      }}
                    >
                      {item.title}
                    </h6>
                    <p
                      style={{
                        fontSize: "13px",
                        color: "#999",
                        marginBottom: "16px",
                        lineHeight: "1.6",
                      }}
                    >
                      {item.shortDesc}
                    </p>
                    <a
                      href="#"
                      style={{
                        display: "inline-block",
                        color: "#a07242",
                        fontWeight: "600",
                        fontSize: "13px",
                        textDecoration: "none",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                      }}
                      onMouseEnter={(e) =>
                        (e.target.style.textDecoration = "underline")
                      }
                      onMouseLeave={(e) =>
                        (e.target.style.textDecoration = "none")
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(`/blog/${item.slug}`);
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }}
                    >
                      Read More →
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default BlogLandingPage;